    
    
    export function getBackendDateTimeFormat(dateTime){
        if (dateTime) {
            const formattedDateAndTime = new Date(dateTime).toISOString().slice(0, 16);
            return formattedDateAndTime || null;
        }
        return null;
    }


    export function setReduxFormatDateTime(dateTime) {

        if (dateTime) {
            const raw = dateTime;
            let formattedDateAndTime = raw;
            if (raw) {
                const date = new Date(raw);
                if (!isNaN(date.getTime())) {
                    const pad = (n) => String(n).padStart(2, "0");
                    formattedDateAndTime = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
                }
            }

            return formattedDateAndTime || "";
        }
        return "";
    }
    
